export default __webpack_public_path__ + "img/newJoin.eff81a9c.svg";